import type { Language } from '@/utilities/language';

export interface ContactInformation {
  phone: string;
  email: string;
  instagram: string;
  facebook: string;
  website: string;
}

export const contact: Record<Language, ContactInformation> = {
  //  yachtas: {
  //    cs: {
  //      phone: '+420 604 290 820',
  //      email: 'plavby@yachtas.cz',
  //      instagram: 'https://www.instagram.com/yachtas_official/',
  //      facebook: 'https://www.facebook.com/yachtascz/',
  //      website: 'https://yachtas.cz',
  //    },
  //    sk: {
  //      phone: '+421 910 130 222',
  //      email: 'plavby@yachtas.sk',
  //      instagram: 'https://www.instagram.com/yachtas_official/',
  //      facebook: 'https://www.facebook.com/yachtascz/',
  //      website: 'https://yachtas.sk',
  //    },
  //  },
  cs: {
    phone: '+420 731 562 127',
    email: 'plavby@nautyy.cz',
    instagram: 'https://www.instagram.com/nautyy_ck/',
    facebook: 'https://www.facebook.com/ck.nautyy',
    website: 'https://nautyy.cz',
  },
  sk: {
    phone: '+421 910 130 222',
    email: 'plavby@nautyy.sk',
    instagram: 'https://www.instagram.com/nautyy_ck/',
    facebook: 'https://www.facebook.com/ck.nautyy',
    website: 'https://nautyy.sk',
  },
};
